<template>
    <div class="webinar-exam-creator">
        <div class="section-header">Moduły</div>
        <div v-for="(module, index) in modules" :key="index">
            <EditSection
                accent="apple"
                :errors="errors"
                :sections="module.section"
                :ref="`module-section-${index}`"
                section="accountSections"
            />
            <ExamCreator :errors="errors" :ref="`examCreator-${index}`" />
            <ActionButton
                label="Usuń moduł"
                color="red"
                materialIcon="delete"
                style="margin-top: 2rem;"
                @click="removeModule(index)"
            />
        </div>
        <div style="display: flex; margin-top: 2rem;">
            <ActionButton
                label="Dodaj moduł"
                color="orange"
                materialIcon="add"
                @click="addModule"
            />
        </div>
    </div>
</template>
<script>
export default {
    components: {
        ExamCreator: () => import('../ExamCreator')
    },
    props: {
        errors: Object
    },
    data() {
        return {
            modules: [
                {
                    section: {
                        title: {
                            title: 'Tytuł',
                            value: '',
                            type: 'text-input',
                            key: 'title',
                            color: '#FFF',
                            size: 3
                        },
                        subtitle: {
                            title: 'Podtytuł',
                            value: '',
                            type: 'text-input',
                            key: 'subtitle',
                            color: '#FFF',
                            size: 2
                        },
                        video_url: {
                            title: 'Video URL',
                            value: '',
                            type: 'text-input',
                            key: 'video_url',
                            color: '#FFF',
                            size: 2
                        },
                        description: {
                            title: 'Opis',
                            value: '',
                            type: 'text-editor',
                            key: 'description',
                            color: '#FFF'
                        },
                        attachments: {
                            title: 'Załączniki',
                            value: [],
                            type: 'attachments-input',
                            key: 'attachments',
                            color: '#FFF'
                        }
                    },
                    exam: {}
                }
            ]
        }
    },
    methods: {
        removeModule(index) {
            this.modules.splice(index, 1)
        },
        addModule() {
            this.modules.push({
                section: {
                    title: {
                        title: 'Tytuł',
                        value: '',
                        type: 'text-input',
                        key: 'title',
                        color: '#FFF',
                        size: 3
                    },
                    subtitle: {
                        title: 'Podtytuł',
                        value: '',
                        type: 'text-input',
                        key: 'subtitle',
                        color: '#FFF',
                        size: 2
                    },
                    video_url: {
                        title: 'Video URL',
                        value: '',
                        type: 'text-input',
                        key: 'video_url',
                        color: '#FFF',
                        size: 2
                    },
                    description: {
                        title: 'Opis',
                        value: '',
                        type: 'text-editor',
                        key: 'description',
                        color: '#FFF'
                    },
                    attachments: {
                        title: 'Załączniki',
                        value: [],
                        type: 'attachments-input',
                        key: 'attachments',
                        color: '#FFF'
                    }
                },
                exam: {}
            })
        },
        async getModules() {
            let isIvalid = true
            await this.uploadFiles()
            const values = this.modules.map((m, index) => {
                const title = m.section.title.value
                const subtitle = m.section.subtitle.value
                const video_url = m.section.video_url.value
                const description = m.section.description.value
                const attachments = m.section.attachments.value
                const exam = this.$refs[`examCreator-${index}`][0].getExam()
                if (
                    !title ||
                    !subtitle ||
                    !video_url ||
                    !description ||
                    !exam
                ) {
                    isIvalid = false
                }
                return {
                    id: index + 1,
                    title: title,
                    subtitle: subtitle,
                    video_url: video_url,
                    attachments: attachments,
                    description: description,
                    exam: exam
                }
            })
            return isIvalid ? values : false
        },
        uploadFiles() {
            const promises = this.modules.map((m, index) => {
                return this.$refs[`module-section-${index}`][0].uploadFiles()
            })
            return Promise.all(promises)
        },
        setModules(modules) {
            this.modules = modules.map(section => {
                return {
                    section: {
                        title: {
                            title: 'Tytuł',
                            value: section.title,
                            type: 'text-input',
                            key: 'title',
                            color: '#FFF',
                            size: 3
                        },
                        subtitle: {
                            title: 'Podtytuł',
                            value: section.subtitle,
                            type: 'text-input',
                            key: 'subtitle',
                            color: '#FFF',
                            size: 2
                        },
                        video_url: {
                            title: 'Video URL',
                            value: section.video_url,
                            type: 'text-input',
                            key: 'video_url',
                            color: '#FFF',
                            size: 2
                        },
                        description: {
                            title: 'Opis',
                            value: section.description,
                            type: 'text-editor',
                            key: 'description',
                            color: '#FFF'
                        },
                        attachments: {
                            title: 'Załączniki',
                            value: section.attachments
                                ? section.attachments
                                : [],
                            type: 'attachments-input',
                            key: 'attachments',
                            color: '#FFF'
                        }
                    },
                    exam: section.exam
                }
            })
            this.$nextTick(() => {
                this.modules.forEach((m, index) => {
                    this.$refs[`examCreator-${index}`][0].setQuestions(m.exam)
                })
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.exam-answer {
    margin-bottom: 1rem;
}
.answer-key {
    font-family: $input-family;
    text-transform: capitalize;
    padding: 0.6rem 0;
}
.section-header {
    padding: 0.6rem 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 1.4rem;
    color: $accent-apple;
    font-family: 'SofiaProSemiBold';
}
</style>
